import { ScrollView, Text, View, useWindowDimensions } from 'react-native';
import { Sparkles } from 'lucide-react-native';

import { Card } from '@/components/ui';
import { colors, radius, typography } from '@/theme/tokens';
import { APP_VERSION, CHANGELOG } from '@/version';

export function NotasVersionScreen() {
  const { width } = useWindowDimensions();
  const wide = width >= 920;

  return (
    <ScrollView contentContainerStyle={{ padding: wide ? 28 : 16, gap: 16, paddingBottom: 80 }}>
      <View
        style={{
          padding: wide ? 22 : 18,
          borderRadius: radius['3xl'],
          backgroundColor: colors.magenta[700],
          // @ts-ignore web only
          backgroundImage: `linear-gradient(135deg, ${colors.magenta[800]} 0%, ${colors.magenta[600]} 100%)`,
        }}
      >
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
          <Sparkles size={20} color={colors.white} />
          <Text style={{ color: 'rgba(255,255,255,0.85)', fontSize: 11, fontWeight: typography.weights.bold, letterSpacing: 1.4, textTransform: 'uppercase' }}>
            Notas de versión
          </Text>
        </View>
        <Text style={{ color: colors.white, fontFamily: typography.display.fontFamily, fontSize: wide ? 30 : 24, fontWeight: typography.weights.bold, marginTop: 4 }}>
          CliniCAT v{APP_VERSION}
        </Text>
        <Text style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, marginTop: 2 }}>
          Acá ves todo lo que se fue agregando y cambiando en la app.
        </Text>
      </View>

      {CHANGELOG.map((release, idx) => (
        <Card key={release.version}>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <View
              style={{
                paddingHorizontal: 10,
                paddingVertical: 4,
                borderRadius: 999,
                backgroundColor: idx === 0 ? colors.magenta[700] : colors.crema[100],
              }}
            >
              <Text
                style={{
                  fontSize: 12,
                  fontWeight: typography.weights.bold,
                  color: idx === 0 ? colors.white : colors.ink[700],
                }}
              >
                v{release.version}
              </Text>
            </View>
            {idx === 0 ? (
              <View style={{ paddingHorizontal: 8, paddingVertical: 3, borderRadius: 999, backgroundColor: colors.success[50] }}>
                <Text style={{ fontSize: 10, fontWeight: typography.weights.bold, color: colors.success[600], letterSpacing: 0.6, textTransform: 'uppercase' }}>
                  Actual
                </Text>
              </View>
            ) : null}
            <Text style={{ fontSize: 12, color: colors.ink[500] }}>{release.fecha}</Text>
          </View>

          <Text style={{ fontFamily: typography.display.fontFamily, fontSize: 18, fontWeight: typography.weights.bold, color: colors.ink[900], marginTop: 8 }}>
            {release.titulo}
          </Text>

          {/* Formato "Pidieron → Hicimos" */}
          {release.pedidos && release.pedidos.length > 0 ? (
            <View style={{ gap: 12, marginTop: 12 }}>
              {release.pedidos.map((p, i) => (
                <View key={i} style={{ borderRadius: radius.xl, borderWidth: 1, borderColor: colors.ink[100], overflow: 'hidden' }}>
                  <View style={{ flexDirection: 'row', gap: 8, alignItems: 'flex-start', padding: 12, backgroundColor: colors.crema[50] }}>
                    <Text style={{ fontSize: 11, fontWeight: typography.weights.bold, color: colors.magenta[700], letterSpacing: 0.4, textTransform: 'uppercase', marginTop: 1 }}>
                      Pidieron
                    </Text>
                    <Text style={{ flex: 1, fontSize: 13, color: colors.ink[800], fontStyle: 'italic', lineHeight: 19 }}>
                      “{p.pedido}”
                    </Text>
                  </View>
                  <View style={{ flexDirection: 'row', gap: 8, alignItems: 'flex-start', padding: 12 }}>
                    <Text style={{ fontSize: 11, fontWeight: typography.weights.bold, color: colors.success[600], letterSpacing: 0.4, textTransform: 'uppercase', marginTop: 1 }}>
                      Hicimos
                    </Text>
                    <Text style={{ flex: 1, fontSize: 13, color: colors.ink[700], lineHeight: 19 }}>
                      {p.hicimos}
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          ) : null}

          {release.cambios && release.cambios.length > 0 ? (
            <View style={{ gap: 8, marginTop: 10 }}>
              {release.cambios.map((cambio, i) => (
                <View key={i} style={{ flexDirection: 'row', gap: 10, alignItems: 'flex-start' }}>
                  <View style={{ width: 6, height: 6, borderRadius: 3, backgroundColor: colors.magenta[500], marginTop: 6 }} />
                  <Text style={{ flex: 1, fontSize: 13, color: colors.ink[700], lineHeight: 19 }}>
                    {cambio}
                  </Text>
                </View>
              ))}
            </View>
          ) : null}
        </Card>
      ))}
    </ScrollView>
  );
}
